import { Link, useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "@/lib/constants";
import { getTrack } from "@/lib/tracks";

const MobileBottomBar = () => {
    const { pathname } = useLocation();
    const track = getTrack(pathname);
    return (
        <div
            className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 md:hidden shadow-[0_-4px_14px_rgba(0,0,0,0.18)]"
            role="navigation"
            aria-label="Mobile call-to-action bar"
            data-testid="mobile-bottom-bar"
        >
            <a
                href={COMPANY.phoneHref}
                className="flex items-center justify-center gap-2 h-14 bg-brand-dark text-white font-semibold text-sm uppercase tracking-wider hover:bg-black transition-colors duration-200"
                data-testid="mobile-bar-call"
            >
                <Phone className="h-5 w-5" strokeWidth={2.25} />
                Call Now
            </a>
            <Link
                to={track.contact}
                className="flex items-center justify-center gap-2 h-14 bg-brand-coral text-white font-semibold text-sm uppercase tracking-wider hover:bg-[#d04438] transition-colors duration-200"
                data-testid="mobile-bar-quote"
            >
                <FileText className="h-5 w-5" strokeWidth={2.25} />
                Get Quote
            </Link>
        </div>
    );
};

export default MobileBottomBar;
